import { getAppLinks } from "../../config/chains";

// Get chain-specific links
const appLinks = getAppLinks();

export const LINKS = {
  home: appLinks.home,
  docs: appLinks.docs,
  apidocs: appLinks.apiReference ?? "#",
  twitter: appLinks.twitter,
  discord: appLinks.discord,
  github: appLinks.github,
  blog: "#",
  dashboard: "#",
  mediakit: appLinks.mediaKit ?? "#",
  uptimeRobot: "#",
  termsOfService: appLinks.termsOfService,
  openSea: "#",
  /**
   * The app's own origin (the page the user is on). It was API_URL, so the
   * referral Copy buttons and the PWA QR code pointed at the backend host.
   * A getter, so it is read when used rather than at module load.
   */
  get app(): string {
    return typeof window !== "undefined" ? window.location.origin : "";
  },
  telegram: appLinks.telegram,
} as const;

export const REWARD_LINKS = {
  week1: "#",
  week2: "#",
  week3: "#",
  week4: "#",
  referralClaims: "#",
};

export const getRewardsLinkForLabel = (label?: string) => {
  if (
    label?.toLowerCase() === "taker leaderboard rewards #1" ||
    label?.toLowerCase() === "taker incentive rewards #1"
  ) {
    return REWARD_LINKS.week2;
  }
  if (
    label?.toLowerCase() === "taker leaderboard rewards #2" ||
    label?.toLowerCase() === "taker incentive rewards #2"
  ) {
    return REWARD_LINKS.week3;
  }
  if (
    label?.toLowerCase() === "taker leaderboard rewards #3" ||
    label?.toLowerCase() === "taker incentive rewards #3"
  ) {
    return REWARD_LINKS.week3;
  }
  if (label?.toLowerCase() === "claim_referral_rewards") {
    return REWARD_LINKS.referralClaims;
  }
  return undefined;
};
